
import { environment } from 'src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Subscription } from "./models/subscription";
import { ESubscriptionType } from "./enum/e-subscription-type";
import { Package } from '../packages/models/package';

@Injectable({
providedIn: 'root'
})
export class SubscriptionApiService {
  private baseUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient
  ) {
  }

  getApiUrlCall(endUrl) {
    return this.baseUrl + endUrl;
  }

  getSubscriptions(subscriptionType : ESubscriptionType): Observable<Subscription[]> {
    const url = this.getApiUrlCall('api/Subscriptions/' + subscriptionType);
    return this.http.get<Subscription[]>(url);
  }

  getSubscription(subscriptionId : number): Observable<Subscription> {
    const url = this.getApiUrlCall('api/Subscriptions/' + subscriptionId);
    return this.http.get<Subscription>(url);
  }

  GetLastSubscriptionByPackage(discriminator : string, packageId : number): Observable<Subscription> {
    const url = this.getApiUrlCall('api/Subscriptions/getSubscriptionByPackage/' + discriminator + "/" + packageId);
    return this.http.get<Subscription>(url);
  }
  
  createSubscription(subscription: Subscription): Observable<Subscription> {
    const url = this.getApiUrlCall('api/Subscriptions');
    return this.http.post<Subscription>(url, subscription);
  }

  deleteSubscription(subscription: Subscription): Observable<number> {
    const url = this.getApiUrlCall("api/Subscriptions/" + subscription.id);
    return this.http.delete<number>(url);
  }

  editSubscription(subscription: Subscription): Observable<any> {
    const url = this.getApiUrlCall("api/Subscriptions/" + subscription.id);
    return this.http.put(url, subscription);
  }

  createCheckoutSession(pack: Package): Observable<Subscription> {
    const url = this.getApiUrlCall('api/Subscriptions/createCheckoutSession');
    return this.http.post<Subscription>(url, pack);
  }

  revokeUserSubscriptionBypackage(discriminator : string, packageId : number): Observable<boolean> {
    const url = this.getApiUrlCall('api/Subscriptions/deleteSubscriptionUserByPackage/' + discriminator + "/" + packageId);
    return this.http.get<boolean>(url);
  }
  

}

